import i18next from 'i18next'
import { Company } from '../../../types/company/Company'
import { DimensionTree } from '../components/DimensionTree'
import { Dimension } from '../types/Dimension'

export const dimensionTreeWithRootSelector = (companyId: Company['id'], dimensions?: Dimension[]) => {
  return {
    companyId,
    id: -1,
    order: -1,
    dimensionId: 'null',
    name: i18next.t('global:enterpriseLevel'),
    children: dimensions
  } as Dimension
}

export const dimensionByIdSelector = (dimensions: Dimension[] = [], id: string) =>
  dimensions.find(dimension => dimension.dimensionId === id)

export const dimensionsArgumentOptionsSelector = (dimensions: Dimension[] = []) =>
  dimensions?.map(dimension => ({
    name: `${dimension.dimensionId} - ${dimension.name}`,
    value: `'${dimension.dimensionId}'`
  }))

export const DTSelector = (dimensionList: Dimension[]): DimensionTree => {
  const tree = new DimensionTree()
  tree.build(dimensionList)
  return tree
}

export const dimensionStringSelector = (dimensionList: Dimension[], dimensions?: string[]) => {
  const dimensionTree = DTSelector(dimensionList)
  const values = dimensionTree.getDimensionText(dimensions)
  return values
}

export const dimensionTextSelector = (dimensionList: Dimension[], dimensions?: string[]) => {
  const dimensionTree = DTSelector(dimensionList)
  const values = dimensionTree.getNamedSubTrees(dimensions)
  return values
}

export const dimensionChildrenMapSelector = (flatList: Dimension[]): Map<string | null, Dimension[]> => {
  const map = new Map<string | null, Dimension[]>()

  for (const dim of flatList) {
    const parentId = dim.parentDimensionId ?? null
    if (!map.has(parentId)) {
      map.set(parentId, [])
    }
    map.get(parentId)!.push(dim)
  }

  return map
}

/**
 * Creates a Map for quick dimension lookup by dimensionId
 * @param dimensions - Array of dimensions
 * @returns Map<dimensionId, Dimension>
 */
export const dimensionMapSelector = (dimensions: Dimension[]): Map<string, Dimension> => {
  return new Map(dimensions.map(d => [d.dimensionId, d]))
}
